import { render, staticRenderFns } from "./SMALLTITLE.vue?vue&type=template&id=f6aeab30&scoped=true&lang=pug"
import script from "./SMALLTITLE.vue?vue&type=script&lang=js"
export * from "./SMALLTITLE.vue?vue&type=script&lang=js"
import style0 from "./SMALLTITLE.vue?vue&type=style&index=0&id=f6aeab30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6aeab30",
  null
  
)

export default component.exports